import { NodeAxios } from '@/services/api'
import type { HeftProfileCuration } from './heft-profile-curation-service'

export type HeftSubjectType = 'person' | 'company' | 'product' | 'group'

export interface ProcessingLensesResponse {
    success: boolean
    data: {
        org_defaults: { enabled_lenses: string[] }
        subject_override: { enabled_lenses: string[] } | null
        effective_enabled_lenses: string[]
    }
}

export const heftProcessingLensSettingsService = {
    get(params: { subjectType: HeftSubjectType; subjectId: string }) {
        return NodeAxios.get(
            `/heft-profile/processing-lenses/${params.subjectType}/${params.subjectId}`
        ) as Promise<ProcessingLensesResponse>
    },

    putSubjectOverride(params: { subjectType: HeftSubjectType; subjectId: string; enabled_lenses: string[] }) {
        return NodeAxios.put(`/heft-profile/processing-lenses/${params.subjectType}/${params.subjectId}`, {
            enabled_lenses: params.enabled_lenses,
            editIntent: 'usage',
            compatibilityWrite: true,
        }) as Promise<{
            success: boolean
            data: {
                settings: unknown
                curation?: HeftProfileCuration
                lens_identities_created?: string[]
            }
        }>
    },

    backfill(params: { subjectType: HeftSubjectType; subjectId: string; lens: string }) {
        return NodeAxios.post(`/heft-profile/${params.subjectType}/${params.subjectId}/story-variants/backfill`, {
            lens: params.lens,
            editIntent: 'presentation',
            compatibilityWrite: true,
        }) as Promise<{ success: boolean; data: { base_story_count: number; created: number; skipped: number } }>
    },
}
